"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tab = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react/no-children-prop */


var styles = {
  "tab": "lbc_y6W"
};
var Tab = (0, _reactRouterDom.withRouter)(function (_ref) {
  var children = _ref.children,
      route = _ref.route,
      location = _ref.location,
      history = _ref.history,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component;
  return _react.default.createElement("div", {
    className: styles.tab,
    onClick: function onClick() {
      return history.replace(route);
    }
  }, _react.default.createElement(component, {
    children: children
  }));
});
exports.Tab = Tab;
var _default = Tab;
exports.default = _default;